import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Lang, LANGUAGES } from './shared/enum/laguages.enum';
import {
  StorageParameters,
  StorageService,
} from './shared/services/storage.service';
import * as Sentry from '@sentry/angular-ivy';
import { NavigationError, Router } from '@angular/router';
import { environment } from '@admin-env/environment';
import { CurrentFoundationService } from './shared/services/current-foundation.service';
import { ApiCallsInProgress } from './shared/services/api-calls-in-progress.service';
import { Subscription } from 'rxjs';
import PubNub from 'pubnub';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MobileService } from '@admin-shared/services/mobile.service';

const getUUID = () => {
  try {
    const uuid = localStorage.getItem('pubnub-uuid');
    if (uuid) return uuid;
  } catch (e) {}
  const uuid = PubNub.generateUUID();
  try {
    localStorage.setItem('pubnub-uuid', uuid);
  } catch (e) {}
  return uuid;
};

const pubNub = new PubNub({
  publishKey: environment.PUBLISH_KEY,
  subscribeKey: environment.SUBSCRIBE_KEY,
  ssl: true,
  uuid: getUUID(),
});

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'dash-admin';
  apiCallObs?: Subscription;
  showLoading = false;

  constructor(
    private translateService: TranslateService,
    private storage: StorageService,
    private router: Router,
    private currentFoundationService: CurrentFoundationService,
    private apiCallsInProgress: ApiCallsInProgress,
    private breakpointObserver: BreakpointObserver,
    private mobileService: MobileService
  ) {
    const storageLang = this.storage.getItem(StorageParameters.lang);
    this.translateService.setDefaultLang('en');
    this.switchLanguage(storageLang ?? this.translateService.getBrowserLang());
    this.router.events.subscribe((navigation) => {
      if (navigation instanceof NavigationError) {
        Sentry.captureException(navigation.error);
      }
    });
  }

  ngOnInit() {
    pubNub.subscribe({
      channels: ['bids'],
      withPresence: true,
    });
    pubNub.addListener({
      message: (msg) => this.currentFoundationService.setPubnubMessage(msg),
      status: (status) => this.currentFoundationService.setPubnubStatus(status),
    });
    this.breakpointObserver
      .observe(['(max-width: 700px)'])
      .subscribe((e) => this.mobileService.setMobileFlag(e.matches));
    this.apiCallObs = this.apiCallsInProgress
      .getObservable()
      .subscribe((calling) => {
        setTimeout(() => {
          this.showLoading = calling > 0;
        }, 0);
      });
  }

  ngOnDestroy(): void {
    this.apiCallObs?.unsubscribe();
  }

  public switchLanguage(language: string): void {
    this.translateService.use(
      LANGUAGES.includes(language as Lang) ? language : Lang.EN
    );
  }
}
